import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { firestore } from 'firebase/app';
import { Schedule } from 'src/app/interfaces/installation';
import { FunctionsService } from 'src/app/services/functions/functions.service';

interface Day {
  id: string;
  tag: string;
  open: boolean;
  schedules: DaySchedule[];
  count: number;
}
interface DaySchedule {
  id: number;
  opens: ScheduleTime;
  closes: ScheduleTime;
  hasError?: boolean;
}

interface ScheduleTime {
  hour: string;
  minutes: string;
  md: string;
}

@Component({
  selector: 'app-manager-schedule',
  templateUrl: './manager-schedule.page.html',
  styleUrls: ['./manager-schedule.page.scss'],
})
export class ManagerSchedulePage implements OnInit {
  @Input() schedule: Schedule[];
  @Input() editable: boolean;

  days: Day[] = [
    { id: 'monday', tag: 'MON', open: false, schedules: [], count: 1 },
    { id: 'tuesday', tag: 'TUE', open: false, schedules: [], count: 1 },
    { id: 'wednesday', tag: 'WED', open: false, schedules: [], count: 1 },
    { id: 'thursday', tag: 'THU', open: false, schedules: [], count: 1 },
    { id: 'friday', tag: 'FRI', open: false, schedules: [], count: 1 },
    { id: 'saturday', tag: 'SAT', open: false, schedules: [], count: 1 },
    { id: 'sunday', tag: 'SUN', open: false, schedules: [], count: 1 },
  ];

  today = new Date();
  hours: string[] = [];
  minutes: string[] = [];
  mdm = ['AM', 'PM'];

  copiedDayIndex: number;

  constructor(
    public modalCtrl: ModalController,
    private funcServ: FunctionsService,
    public translate: TranslateService
  ) {}

  ngOnInit() {
    this.loadData();
  }

  formatInstSchedule(sch: firestore.Timestamp): ScheduleTime {
    const formattedTime: ScheduleTime = { hour: '', minutes: '', md: '' };
    const hours = sch.toDate().getHours();
    const minutes = sch.toDate().getMinutes();
    if (hours === 0) {
      formattedTime.hour = '12';
      formattedTime.md = 'AM';
    } else if (hours === 12) {
      formattedTime.hour = '12';
      formattedTime.md = 'PM';
    } else if (hours > 12 && hours <= 24) {
      formattedTime.md = 'PM';
      hours < 22
        ? (formattedTime.hour = '0' + (hours - 12).toString())
        : (formattedTime.hour = (hours - 12).toString());
    } else if (hours < 12) {
      formattedTime.md = 'AM';
      hours < 10
        ? (formattedTime.hour = '0' + hours.toString())
        : (formattedTime.hour = hours.toString());
    }
    minutes < 10
      ? (formattedTime.minutes = '0' + minutes.toString())
      : (formattedTime.minutes = minutes.toString());
    return formattedTime;
  }

  autoCompleteDays() {
    this.days.forEach((d) => {
      d.schedules.push({
        id: 0,
        opens: { hour: '12', minutes: '00', md: 'AM' },
        closes: { hour: '12', minutes: '00', md: 'AM' },
      });
    });
  }

  loadData() {
    for (let i = 1; i <= 12; i++) {
      i < 10
        ? this.hours.push('0' + i.toString())
        : this.hours.push(i.toString());
    }
    for (let i = 0; i <= 59; i += 5) {
      i < 10
        ? this.minutes.push('0' + i.toString())
        : this.minutes.push(i.toString());
    }
    if (this.schedule) {
      this.days.forEach((d) => {
        const iD = this.schedule.find((idf) => idf.id === d.id);
        d.open = iD.open;
        if (iD.schedules) {
          d.count = iD.schedules.length;
          iD.schedules.forEach((s, index) => {
            d.schedules.push({
              id: index,
              opens: this.formatInstSchedule(s.opens),
              closes: this.formatInstSchedule(s.closes),
            });
          });
        } else {
          d.schedules.push({
            id: 0,
            opens: { hour: '12', minutes: '00', md: 'AM' },
            closes: { hour: '12', minutes: '00', md: 'AM' },
          });
        }
      });
    }
  }

  openDay(day: Day) {
    if (day.open && !(day.schedules.length > 0)) {
      this.addSchedule(day.id);
    }
  }

  addSchedule(id: string) {
    const day = this.days.findIndex((d) => d.id === id);
    this.days[day].count++;
    this.days[day].schedules.push({
      id: this.days[day].count - 1,
      opens: { hour: '12', minutes: '00', md: 'AM' },
      closes: { hour: '12', minutes: '00', md: 'AM' },
    });
  }

  removeSchedule(id: string, count: number) {
    const day = this.days.findIndex((d) => d.id === id);
    this.days[day].schedules.length === 1
      ? null
      : this.days[day].schedules.splice(count, 1),
      this.days[day].count--;
    this.days[day].schedules = [...this.days[day].schedules];
  }

  copySchedule(id: string) {
    this.copiedDayIndex = this.days.findIndex((d) => d.id === id);
    this.funcServ.showToast('Horario copiado', 'cerulean');
  }

  pasteSchedule(id: string) {
    const day = this.days.findIndex((d) => d.id === id);
    const copy = Object.assign({}, this.days[this.copiedDayIndex]);
    this.days[day].count = copy.count;
    this.days[day].schedules = copy.schedules;
    this.funcServ.showToast('Horario aplicado', 'cerulean');
  }

  timeChange(
    id: string,
    index: number,
    time: string,
    type: string,
    value: string
  ) {
    const day = this.days.findIndex((d) => d.id === id);
    this.days[day].schedules[index][time][type] = value;
  }

  checkForError() {
    let errorFound = false;
    this.days.forEach((day) => {
      if (day.open) {
        day.schedules.forEach((sch, i) => {
          if (sch.opens.md === sch.closes.md) {
            if (sch.opens.hour === sch.closes.hour) {
              // tslint:disable-next-line:no-unused-expression
              sch.opens.minutes < sch.closes.minutes
                ? null
                : (errorFound = true);
            } else if (
              sch.opens.hour > sch.closes.hour &&
              sch.opens.hour !== '12'
            ) {
              errorFound = true;
            } else if (
              sch.opens.hour < sch.closes.hour &&
              sch.closes.hour === '12'
            ) {
              errorFound = true;
            }
          } else if (sch.closes.md === 'AM' && sch.opens.md === 'PM') {
            errorFound = true;
          }
          if (errorFound) {
            sch.hasError = true;
            return errorFound;
          } else {
            sch.hasError = false;
          }
        });
      }
    });
    return errorFound;
  }

  formatTime(time: ScheduleTime): Date {
    let hours = Number(time.hour);
    const minutes = Number(time.minutes);
    if (time.md === 'PM' && hours < 12) {
      hours += 12;
    } else if (time.md === 'AM' && hours === 12) {
      hours = 0;
    }
    this.today.setHours(hours, minutes, 0);
    return this.today;
  }

  doSave() {
    const instSchedule: Schedule[] = [];
    if (!this.checkForError()) {
      this.days.forEach((day, index) => {
        instSchedule.push({
          id: day.id,
          open: day.open,
        });
        day.schedules.forEach((sch) => {
          if (day.open) {
            !instSchedule[index].schedules
              ? (instSchedule[index].schedules = [])
              : null;
            instSchedule[index].schedules.push({
              id: sch.id.toString(),
              opens: firestore.Timestamp.fromDate(this.formatTime(sch.opens)),
              closes: firestore.Timestamp.fromDate(this.formatTime(sch.closes)),
            });
          }
        });
      });
      this.funcServ
        .showToast('Guarde los cambios para actualizar el horario', 'success')
        .then(() => {
          this.modalCtrl.dismiss(instSchedule);
        });
    } else {
      this.funcServ.showToast(
        'Existe un error en los datos proporcionados',
        'danger'
      );
    }
  }
}
